import classes from "./Experience.module.scss";

// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/pagination";
// import { Mousewheel } from "swiper";

const Experience = (props) => {
  const { isDark } = props;
  return (
    <div className={classes.skills} id="skills">
      <div className={classes.skills_heading}>Experience</div>
      <div className={classes.skills_container}>
        <div
          className={classes.slide}
          style={{
            background: isDark
              ? `linear-gradient(
                211.13deg,
                rgba(254, 254, 254, 0.06) 12.68%,
                rgba(254, 254, 254, 0) 81.17%
            )`
              : `linear-gradient(211.13deg, rgba(249, 105, 131, 0.04) 12.68%, rgba(203, 92, 230, 0.02) 81.17%)`,
            border: isDark
              ? "1px solid rgba(254, 254, 254, 0.12)"
              : "1px solid rgba(203, 92, 230, 0.52)",
          }}
        >
          <div className={classes.slide_heading}>Freelancer</div>
          <div className={classes.slide_content}>June 2020 - Present</div>
        </div>
        <div
          className={classes.slide}
          style={{
            background: isDark
              ? `linear-gradient(
                211.13deg,
                rgba(254, 254, 254, 0.06) 12.68%,
                rgba(254, 254, 254, 0) 81.17%
            )`
              : `linear-gradient(211.13deg, rgba(249, 105, 131, 0.04) 12.68%, rgba(203, 92, 230, 0.02) 81.17%)`,
            border: isDark
              ? "1px solid rgba(254, 254, 254, 0.12)"
              : "1px solid rgba(203, 92, 230, 0.52)",
          }}
        >
          <div className={classes.slide_heading}>
            Software Developer <br />
            Crest Data Systems
          </div>
          <div className={classes.slide_content}>June 2021 - Feb 2022</div>
        </div>
        <div
          className={classes.slide}
          style={{
            background: isDark
              ? `linear-gradient(
                211.13deg,
                rgba(254, 254, 254, 0.06) 12.68%,
                rgba(254, 254, 254, 0) 81.17%
            )`
              : `linear-gradient(211.13deg, rgba(249, 105, 131, 0.04) 12.68%, rgba(203, 92, 230, 0.02) 81.17%)`,
            border: isDark
              ? "1px solid rgba(254, 254, 254, 0.12)"
              : "1px solid rgba(203, 92, 230, 0.52)",
          }}
        >
          <div className={classes.slide_heading}>
            Software Developer - Intern <br />
            Crest Data Systems
          </div>
          <div className={classes.slide_content}>June 2021 - June 2021</div>
        </div>
        <div
          className={classes.slide}
          style={{
            background: isDark
              ? `linear-gradient(
                211.13deg,
                rgba(254, 254, 254, 0.06) 12.68%,
                rgba(254, 254, 254, 0) 81.17%
            )`
              : `linear-gradient(211.13deg, rgba(249, 105, 131, 0.04) 12.68%, rgba(203, 92, 230, 0.02) 81.17%)`,
            border: isDark
              ? "1px solid rgba(254, 254, 254, 0.12)"
              : "1px solid rgba(203, 92, 230, 0.52)",
          }}
        >
          <div className={classes.slide_heading}>
            Front End Developer <br />
            SPECTRUM
          </div>
          <div className={classes.slide_content}>2020 & 2021</div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
